<template>
    <div class="home">
        <!--
                <div id="background-image" v-bind:style="{backgroundImage : 'url('+apiUrl+'/'+siteInfos.HomeBackgroundUrl+')'} "></div>
        -->
        <MainNav></MainNav>
        <!-- <div class="top-row">
             <a :href="siteInfos.UrlBoutique" class="">
                 <img v-if="apiUrl+'/'+siteInfos.ImageLogo !== undefined" :src="apiUrl+'/'+siteInfos.ImageLogo" alt="Logo C2R">
             </a>
             <div class="header-backtosite-container">
                 <a :href="siteInfos.UrlBoutique" class="btn back-btn">
                     Retour vers le site
                 </a>
             </div>
         </div>-->

        <div class="center">
            <h1>{{siteInfos.HomeH1}}</h1>
            <h3>{{siteInfos.HomeH2}}</h3>
            <div class="home-links">
                <div to="/preconstructor" class="home-link" @click="freshProject"
                     :data-background-color="siteInfos.Couleur">
                    <p>Démarrer mon projet</p>
                    <img v-if="siteInfos.home_picto_upload" :src="siteInfos.home_picto_upload" alt="image démarrer projet">
                </div>
                <a :href="siteInfos.UrlBoutique+'/mon-compte/devis'" class="home-link" >
                    <p>Modifier un projet existant</p>
                    <img v-if="siteInfos.home_picto_settings" :src="siteInfos.home_picto_settings" alt="image projet existant">
                </a>
            </div>
        </div>
        <svg width="0" height="0">
            <clipPath id="clipPolygon">
                <polygon points="0 82,30 112,300 112,300 0,0 0">
                </polygon>
            </clipPath>
        </svg>
        <div class="footer" v-if="siteInfos.home_footer_links || siteInfos.home_footer_payments">
            <div class="container">
                <div class="row align-items-center justify-content-between">
                    <div class="col-12 col-lg-6" v-if="siteInfos.home_footer_links" v-html="siteInfos.home_footer_links" />
                    <div class="col-12 col-lg-6" v-if="siteInfos.home_footer_payments" v-html="siteInfos.home_footer_payments"/>
                </div>
              <footer>
                <p>Réalisation :<a href="https://industrie.wiboo.fr/configurateur-de-produits-sur-mesure/">Wiboo, spécialiste en configurateurs </a></p>
              </footer>
            </div>
        </div>

        <div class="starter-modal popup-valid" id="starter-modal" v-show="isCTAModalShowing">
            <div class="customer-note">
                <p>Une question ? Rendez-vous sur le chat</p>
                <i class="call-to-action-arrow"></i>
            </div>
            <button class="btn" @click="toggleCtaModal()">J'ai compris</button>
        </div>
        <div class="mask starter-modal" v-show="isCTAModalShowing"></div>

    </div>
</template>


<script>
    import MainNav from "../components/MainNav";

    export default {
        name: 'home',
        components: {MainNav},
        methods: {
            freshProject() {
                this.$store.dispatch('resetState');
                this.$router.push('/preconstructor')
            },
            toggleCtaModal() {
                this.$store.dispatch("closeCTAModal")
            }
        },
        computed: {
            siteInfos() {
                return this.$store.state.siteInfos
            },
            apiUrl() {
                return this.$store.state.apiUrl
            },

            isCTAModalShowing() {
                return this.$store.state.cta_chat && this.siteInfos.RefClient === 1
            }
        },

        mounted() {

        }
    }
</script>


<style>
footer p{
  margin:20px;
  color:#bebebe!important;
}
footer a{
  color:#bebebe!important;
}
    div.popup-valid.starter-modal {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        width: 60%;
        height: 30%;
    }

    .customer-note {
        display: flex;
    }

    .mask.starter-modal {
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 20;

        display: block;
    }

    .call-to-action-arrow {
        width: 0;
        height: 0;
        border: 6px solid;
        border-bottom-color: transparent;
        border-left-color: transparent;
        position: relative;
        display: inline-block;
        color: rgb(233, 167, 6);
        box-sizing: border-box;
        transform: rotate(75deg);
        margin-left: 85px;
        margin-top: 40px;
    }

    .call-to-action-arrow::before {
        content: "";
        right: 0;
        top: -3px;
        position: absolute;
        height: 4px;
        box-shadow: inset 0 0 0 32px;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        width: 85px;
        -webkit-transform-origin: right top;
        transform-origin: right top;
    }

    .customer-warning {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .top-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 10%;
        padding-top: 50px;
    }

    .top-row img {
        width: 261px;
        height: auto;

    }

    #background-image {
        height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        left: 0;
        background-size: cover;
        filter: grayscale(100%);
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
    }

    @media screen and (min-width: 0\0
    ) and (min-resolution: +72dpi) {
        #background-image {
        }
    }

    .home {
        width: 100%;
        height: 100%;
    }

    .home h1 {
        font-size: 2.5rem;
    }

    .home h1,
    .home h3 {
        color: #333;
        font-weight: bold;

    }

    .center {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        height: 75vh;

        padding: 60px;
    }

    .home-links {
        display: flex;
        align-items: center;
        justify-content: space-around;

    }

    .home-link {
        font-size: 23px;
        display: flex;
        height: 125px;
        align-items: center;
        width: 70%;

        cursor: pointer;
    }

    .home-link img {
        width: 90px;
        height: auto;
        cursor: pointer;
    }

    .home-link:hover,
    .home-links:focus {
        font-size: 23px;
        text-decoration: none;
        display: flex;
    }

    .choice {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        color: #fff;
        padding: 20px;
        z-index: 1;
        width: 260px;
    }

    .choice:hover,
    .choice:focus,
    .choice:visited {
        color: #ffffff;
        text-decoration: none;
    }

    .choice:first-child {
        margin-right: 80px;
    }

    .choice > div, .choice > p {
        width: 49%;
        margin: 0;
    }

    .choice img {
        width: 75px;
    }

    .choice::before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        z-index: -1;
        -webkit-clip-path: polygon(0px 82px, 30px 112px, 300px 112px, 300px 0px, 0px 0px);
        clip-path: url("#clipPolygon");
        opacity: 0.9;
        transition: 0.2s opacity;
    }

    .choice:hover::before {
        opacity: 1;
    }

    @media screen and (max-width: 767px) {
        .home > img {
            width: 35%;
            position: relative;
            left: 0;
        }

        .home .center {
            padding: 30px 30px 0;
        }

        .home h1 {
            font-size: 1.5rem;
            line-height: initial;
        }

        .home h3 {
            font-size: 1rem;
            line-height: initial;
            /* margin-bottom: 40px; */
        }

        .home .center {
            top: 50%;
        }

        .home .choices-container {
            flex-wrap: wrap;
            align-items: center;
            width: 80%;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
        }

        .home .choices-container > div, .home .choices-container > a {
            width: 100%;
        }

        .home .choice:first-child {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .home .choice {
            height: 125px;
        }

        .home .footer p {
            width: 100%;
            margin: 20px 0px 10px 0;
        }

        p {
            margin-bottom: 1rem;
        }

        .mobile-wrap {
            flex-wrap: wrap;
        }

        .choice.main-btn::before {
            width: 55%;
            height: 125px;
        }

        .choice.main-btn img {
            width: 55px;
        }

        .choice.main-btn p {
            font-size: 20px;
            width: 30%;
            margin-top: -10px;
        }

    }

    @media screen and (max-width: 520px) {
        .home-links {
            flex-direction: column;
        }

        .home-link {
            font-size: 18px;
            flex-direction: column-reverse;
        }

        .home-link:hover {
            font-size: 20px;
            transition: all .3s;
        }

        .home-link img {
            width: 30%;
            height: auto;
            margin-bottom: 2%;
        }

        .mobile-nav-bloc {
            background: #201d1d;
        }

        .home .choices-container {
            width: 100%
        }

        .choice.main-btn img {
            width: 40px;
        }

        .choice.main-btn p {
            font-size: 16px;
        }

        .home > img {
            top: 15px;
        }

        .home .center {
            top: 300px;
        }
    }

    @media screen and (min-width: 0\0
    ) and (min-resolution: +72dpi) {
        .choice:before {
            background: none;
        }

        .choice {
        }
    }

    .home .header-title {
        display: none;
    }

    .home .footer {
        padding-top: 15px;
    }

    .home .footer p, .home .footer a {
        margin-bottom: 0;
        margin-right: 15px;
        color: #333;
    }

    .home .cards_icon {
        width: 51px;
        height: 32px;
        margin: 0 6px 6px 0;
        background-image: url(/img/cards.png);
    }

    .paypal_icon {
        background-position: 0px -33px;
    }

    .visa_icon {
        background-position: 155px 0px;
    }

    .mastercard_icon {
        background-position: 208px 0px;
    }

    .maestro_icon {
        background-position: -105px 0px;
    }

    .cirrus_icon {
        background-position: -53px 0px;
    }

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        .mobile-wrap {
            margin-top: 20px;
        }
    }

    @media screen and (max-width: 768px) {
        div.popup-valid.starter-modal{
            height: auto;
            width: 100%;
        }
    }
</style>


